<template lang="pug">
  .xingjiang-rights
    .header
      img(src="../../../public/images/member/blue-bg.png")
    .main
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入手机号")
        el-form-item
          .verifycode
            .txt-verfiycode
              input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
            .btn-verifycode
              button(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后重试
        el-form-item
          el-button.btn-submit(@click="handleSubmit") 立即开通，可随时取消
    .btn-notice(@click="noticeVisible = true") 活动规则
    el-dialog(:visible.sync="noticeVisible", title="- 活动规则 -", width="96%")
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
    el-dialog(:visible.sync="toPayVisible", title="订单已创建", width="70%")
      ul.confirmpay-btns
        li
          a.link-pay(:href="payUrl", @click="toPay", target="_blank") 去支付
    el-dialog(:visible.sync="confirmPayVisible", title="支付确认", width="70%")
      ul.confirmpay-btns
        li
          el-button.btn-confirm(type="primary", @click="confirmPay") 已完成支付
        li
          el-button.btn-confirm(type="warning", @click="handleSubmit") 支付未完成？重试一下
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      noticeVisible: false,
      confirmPayVisible: false,
      toPayVisible: false,
      notices: [
        '会员费用：29.8元/月',
        '赠送12个月视频会员，从办理起立即生效，为期12个月，当月会员限当月使用，过期作废。视频会员领取后，有效期自领取日起30天，当月不可更改已兑换成功的会员。',
        '权益说明：客户签约成功并支付会员月费，即可享30元话费券、外卖红包、陀螺好物、爱奇艺会员1折起、移动花卡免费领取的会员专属特权。',
        '权益领取：以上6款会员权益均可通过微信搜索关注“language会员”公众号，在会员权益中通过支付关联的手机号码领取，会员生效期间，30元话费券、视频会员每月均可领取，其余4款会员特权一直可领取。',
        '30元话费券为6张*5元话费减免券，可在“language会员”公众号充值100元话费时直接使用，即仅需支付95元即可获得100元话费。',
        '陀螺好物即百种商品免费领权益，可跳转至微信小程序“陀螺好物”中按页面说明完成相应任务即可免费领取百种商品。',
        '爱奇艺会员最低1元购买权益：最低支付1元购买爱奇艺月度会员。',
        '外卖红包权益：每天可通过“language会员”公众号，领取最高56元的美团外卖红包。',
        '注意事项：请在购买时务必填写正确的需充值的手机号码及短信验证码，本产品为系统自动办理，人工无法手动取消办理或者退款，敬请谅解。',
      ],
      form: {
        mobile: '',
        verifyCode: '',
        goodsCode: 'WXPAPAY210226001'
      },
      payUrl: '',
      channel: 'TUIA'
    }
  },
  mounted() {
    this.reqNo = localStorage.getItem('language-member-req-no')
    this.form.mobile = localStorage.getItem('language-member-mobile')
    if (this.reqNo) {
      localStorage.removeItem('language-member-req-no')
      this.confirmPay()
    }
  },
  methods: {
    sendVerifyCode() {
      if (this.leftSendTime > 0) {
        return;
      }
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.OrderService
        .sendVerifyCode({
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      this.addMobilePackage()
    },
    toPay() {
      this.toPayVisible = false
      this.confirmPayVisible = true
    },
    confirmPay() {
      let _loading = this.$loading({
        lock: true,
        text: '正在确认签约状态...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .queryPayOrder({
          reqNo: this.reqNo,
          mobile: this.form.mobile
        })
        .then(res => {
          if (res.data.success) {
            if (res.data.sub_data.trade_state.toUpperCase() === 'SUCCESS') {
              this.$message({
                type: 'success',
                message: '签约成功，正在前往Language会员公众号'
              })
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            } else {
              this.$message({
                type: 'warning',
                message: res.data.sub_data.trade_state_desc
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '查询失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      // eslint-disable-next-line
      let _queryStr = location.search.replace(/^\?/, '') + location.hash.replace(/^\#/, '&')
      let _oid = ''
      if (_queryStr) {
        let _querys = _queryStr.split('&')
        _querys.forEach(item => {
          // eslint-disable-next-line
          if (/^a\_oId\=/.test(item)) {
            _oid = item.split('=')[1]
          }
        })
      }
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel,
        channelOrderNo: _oid
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在验证并创建订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            // this.$message({
            //   type: 'success',
            //   message: '订单创建完成，正在前往支付...'
            // })
            // 此处不用等待支付，直接记录转化，后端会确认支付状态后进行转化数据推送
            if (window.countLog) {
              window.countLog.ready(function() {
                window.countLog.init(function() { 
                }, {
                  isCopy: 0,
                  pageType: 0 
                })
              })
            }
            this.reqNo = res.data.sub_data.req_no
            localStorage.setItem('language-member-req-no', res.data.sub_data.req_no)
            localStorage.setItem('language-member-mobile', this.form.mobile)
            location.href = res.data.sub_data.pay_url
            // this.toPayVisible = true
            // this.payUrl = res.data.sub_data.pay_url
            // window.open(res.data.sub_data.pay_url)
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
            if (res.data.result_code == '1') {
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.xingjiang-rights{
  background-color: #061540;
  padding-bottom: 10rem;
  .header{
    img{
      width: 100%;
    }
  }
  .main{
    width: 80%;
    margin: 0 auto;
    margin-top: -13.5rem;
    padding: 1rem;
    border-radius: 6px;
    .button-item{
      background-color: #ff8324;
      color: #fff;
      width: 100%;
      text-align: center;
      border: 0;
    }
    .verify-btn{
      background-color: #409EFF;
      color: #fff;
    }
    .img-button{
      width: 100%;
      margin-top: -.8rem;
    }
    .verifycode{
      display: flex;
      height: 40px;
      line-height: 40px;
    }
    .btn-verifycode{
      flex: .7;
      button{
        background-color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        width: 100%;
        border: 0;
        outline: 0;
        padding: 0;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    .txt-verfiycode{
      width: 100%;
      flex: 1.3;
      input{
        background-color: #fff;
        // border: 1px solid #DCDFE6;
        border: 0;
        border-right: 0;
        padding: 0 15px;
        outline: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #606266;
        border-radius: 4px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-color: #fff;
        box-sizing: border-box;
        &::-webkit-input-placeholder{
          color: #b9b9b9;
          font-size: 14px;
        }
      }
    }
  }
  .content{
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
  }
  .notice{
    width: 86%;
    padding: 1rem;
    margin: 0 auto;
    margin-top: 3rem;
    background-color: #fff;
    box-shadow: 0 0 3px #a3a3a3;
    border-radius: 6px;
    .title{
      text-align: center;
    }
    
  }
}
.btn-notice{
  position: absolute;
  right: 0;
  top: 2rem;
  word-wrap: break-word;
  width: 1rem;
  font-size: 1rem;
  color: #f3f3f3;
  background-color: rgba(33, 33, 33, .4);
  padding: .5rem;
}
.processing{
  width: 90%;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 2rem;
  border-radius: 6px;
  padding: .8rem 0;
  box-shadow: 0 0 12px #333;
  ol{
    display: flex;
    li{
      flex: 1;
      text-align: center;
      position: relative;
      .title{
        color: #47c1ac;
        margin-bottom: 1rem;
        height: 2.5rem;
      }
      img{
        width: 48px;
        height: 48px;
      }
      &::after{
        background: url('../../../public/images/xinjiang/right.png');
        background-size: 32px 32px;
        content: "";
        width: 32px;
        height: 32px;
        position: absolute;
        right: -0.9rem;
        top: 3.9rem;
      }
      &:last-child{
        &::after{
          width: 0px;
          height: 0px;
          display: none;
        }
      }
    }
  }
}
.btn-confirm{
  width: 100%;
}
.confirmpay-btns{
  li{
    margin-bottom: 2rem;
  }
}
.link-pay{
  display: block;
  text-align: center;
  width: 100%;
  text-decoration: none;
  background-color: rgb(197, 34, 34);
  color: #fff;
  padding: .6rem 0;
  border-radius: 12px;
  font-size: 1.2rem;
}
.btn-feedback{
  position: absolute;
  right: 0;
  top: 9rem;
  word-wrap: break-word;
  width: .6rem;
  font-size: .6rem;
  background-color: rgba(33, 33, 33, .4);
  padding: .5rem;
  a{
    color: #f3f3f3;
    text-decoration: none;
  }
}
.btn-submit{
  width: 100%;
  background-color: rgb(255, 176, 73);
  color: #fff;
  border: 0;
  font-size: 1.2rem;
}
</style>